'use client';

import { IDynamicsOptionSet } from '@/types/dynamicsForms';
import { stateAbbreviationTitles } from '@lamesarv-sdk/tools';
import { PropsWithClasses } from '@lamesarv-sdk/types';
import { Fragment } from 'react';
import { CommonSelect } from './CommonSelect';

interface ICommonServiceSelectProps extends PropsWithClasses {
  servicesOptionSet: IDynamicsOptionSet;
  name?: string;
  label?: string;
  hideLabel?: boolean;
  usePlaceholder?: boolean;
  isRequired?: boolean;
  placeholder?: string;
  classContainer?: string;
  classLabel?: string;
  classLabelWithValue?: string;
  classInputWithValue?: string;
}

export const CommonServiceSelect = (props: ICommonServiceSelectProps) => {
  if (!props.servicesOptionSet) return null;

  const stateLocations = props.servicesOptionSet.reduce(
    (acc, option) => {
      const [center, stateAbbreviation] = option.Label.split(',').map((part) => part.trim());
      if (!stateAbbreviation || !stateAbbreviationTitles[stateAbbreviation]) return acc;
      if (!acc[stateAbbreviation]) acc[stateAbbreviation] = [];
      acc[stateAbbreviation].push({ center, fullLocation: option.Label });
      return acc;
    },
    {} as Record<
      string,
      {
        center: string;
        fullLocation: string;
      }[]
    >,
  );

  const getCustomOptions = () => {
    return (
      <Fragment>
        {Object.entries(stateLocations)
          .sort(([stateAbbreviationA], [stateAbbreviationB]) =>
            stateAbbreviationTitles[stateAbbreviationA].localeCompare(stateAbbreviationTitles[stateAbbreviationB]),
          )
          .map(([stateAbbreviation, locations]) => (
            <optgroup key={stateAbbreviation} label={stateAbbreviationTitles[stateAbbreviation]}>
              {locations.map((location) => (
                <option key={location.center} value={location.fullLocation}>
                  {location.center}
                </option>
              ))}
            </optgroup>
          ))}
      </Fragment>
    );
  };

  return (
    <CommonSelect {...props} name={props.name || 'serviceCenter'} options={[]} optionsCustom={getCustomOptions()} />
  );
};
